import { IMailType } from 'app/shared/model/mail-type.model';

export interface IMailGroup {
  id?: number;
  name?: string;
  mailTypes?: IMailType[];
  social?: string;
  sortOrder?: number;
  hasMore?: boolean;
}

export const defaultValue: Readonly<IMailGroup> = {};
